module.exports = __webpack_public_path__ + "static/media/IMG_4745.a445833f.JPG";